import { FC } from "react";

import { useGetLimitQuery } from "../../../../../api/limit";
import { useCheckActiveSbpTransferQuery, useGetSbpTransferAvailableTermsQuery } from "../../../../../api/sbpTransfer";
import { PageContentLayout } from "../../../../shared/PageContentLayout";
import { SbpTransferPageLimit } from "../SbpTransferPageLimit";
import { SbpTransferPageButton } from "../SbpTransferPageButton";
import { SbpTransferPageSchedule } from "../SbpTransferPageSchedule";
import { SbpTransferPageContentMessage } from "./SbpTransferPageContentMessage";
import { SbpTransferPageAmountAndTerm } from "../SbpTransferPageAmountWithTerm";
import { SbpTransferPageContentPending } from "./SbpTransferPageContentPending";

export const SbpTransferPageContent: FC = () => {
  const { isPending: isLimitPending, isError: isLimitError } = useGetLimitQuery();
  const { isPending: isTermsPending, isError: isTermsError } = useGetSbpTransferAvailableTermsQuery();
  const {
    data: activeTransfer,
    isFetching: isActiveTransferFetching,
  } = useCheckActiveSbpTransferQuery();

  if (isLimitPending || isTermsPending || isActiveTransferFetching) {
    return <SbpTransferPageContentPending />;
  }

  if (isLimitError || isTermsError || activeTransfer?.isTrancheActive) {
    return (
      <SbpTransferPageContentMessage
        isLimitError={isLimitError}
        isTermsError={isTermsError}
        activeTransfer={activeTransfer}
      />
    );
  }

  return (
    <PageContentLayout spacing={2.5}>
      <SbpTransferPageLimit />
      <SbpTransferPageAmountAndTerm />
      <SbpTransferPageSchedule />
      <SbpTransferPageButton />
    </PageContentLayout>
  );
};
